import React from 'react';
import Link from 'gatsby-link';
import graphql from 'graphql';
import Helmet from 'react-helmet';

import Box from '../components/Box';
import Logo from '../components/Logo';

export default class IndexPage extends React.Component {
  render() {
    const { data } = this.props;

    return (
      <section>
        <Helmet
          bodyAttributes={{
            class: 'home'
          }}
        />

        <div className="row">
          <Logo />
          <Box title="Aktuality" id="aktuality" />
          <Box empty={true} />
        </div>

        <div className="row">
          <Box
            title="Daňové poradenství"
            id="danove-poradenstvi"
            ribbonHref="/certifikace"
            ribbonLabel="Certifikace"
          />
          <Box title="Vedení účetnictví" id="vedeni-ucetnictvi" />
          <Box disabled={true} />
          <Box title="Kontakt" id="kontakt" />
        </div>

        <div className="row">
          <Box empty={true} />
          <Box disabled={true} />
          <Box title="Zpracování mezd" id="zpracovani-mezd" />
          <Box empty={true} />
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js